<button type="button" class="close" mat-dialog-close>
     <mat-icon>close</mat-icon>
</button>
<h4 mat-dialog-title>
     {{ (data.isNew ? "trace.create-route.new-poi-title":"trace.poi") | translate}} {{data.index + 1 }}
</h4>
<div mat-dialog-content>
     <!-- <mat-nav-list>
          <mat-list-item [mat-dialog-close]="update(true, data.index)"
              style="background-color: rgba(107, 107, 107, 0.15);color: #f44336;">
              <a matLine color="warn"> {{"trace.create-route.delete-poi" | translate }}</a>
              <mat-icon color='warn'>delete</mat-icon>
          </mat-list-item>
      </mat-nav-list> -->
     <form [formGroup]="editorForm" (ngSubmit)="(false)" novalidate>
          <div class="nameContainer mt-1">
               <mat-form-field  appearance="outline" hintLabel="{{ 'trace.max-length' | translate }} {{data.maxNameLength }}">
                    <mat-label>{{ "trace.field.name" | translate }}</mat-label>
                    <input matInput type="text" name="metadata_name" #metadata_name formControlName="name" />
                    <mat-hint align="end">{{ metadata_name.value?.length || 0 }}/{{data.maxNameLength}}</mat-hint>
               </mat-form-field>
          </div>
          <div class="descContainer">

               <!---
               old method with textarea
               <mat-form-field  appearance="outline" hintLabel="{{ 'trace.max-length' | translate }}  1000">
                    <mat-label>{{ "trace.field.description" | translate }}</mat-label>
                    <textarea matInput name="metadata_desc" #metadata_desc formControlName="desc" cdkTextareaAutosize
                         cdkAutosizeMinRows="1" cdkAutosizeMaxRows="16"                         
                         [pattern]="'^(.|\\n|\\r\\n){0,' + data.maxDescriptionLength + '}$'"></textarea>
                    <mat-hint align="end">{{ metadata_desc.value?.length || 0 }}/{{data.maxDescriptionLength}}
                    </mat-hint>
               </mat-form-field>
               -->

           <mat-form-field appearance="outline" hintLabel="{{ 'trace.max-length' | translate }} {{data.maxDescriptionLength}}" class="form-element">
                <mat-label>{{ "trace.field.description" | translate }}</mat-label>
                <quill-material
                  name="metadata_desc"
                  formControlName="desc"
                ></quill-material>
                <mat-hint align="end">{{ descLength || 0 }}/{{data.maxDescriptionLength}}</mat-hint>
              </mat-form-field> 

          </div>
     </form>
     <!-- <div style="text-align: center;">
          <a mat-button  [mat-dialog-close]="update(true, data.index)"><mat-icon color='warn'>delete</mat-icon>&nbsp; {{"trace.create-route.delete-poi" | translate }}</a>
     </div> -->
</div>
<mat-dialog-actions align="center" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
          <div class="button-container">
                         <a mat-button  [mat-dialog-close]="update(true, data.index)"><mat-icon color='warn'>delete</mat-icon>&nbsp; {{"trace.create-route.delete-poi" | translate }}</a>

          </div>
     <div class="button-container">       
          <button mat-flat-button cdkFocusInitial color="primary" [mat-dialog-close]="update(false, data.index)"
               [ngClass]="{'mat-button-disabled': !editorForm.valid}" [disabled]="!editorForm.valid">
               {{"trace.create-route.save-poi" | translate }}
          </button>
     </div>
     <div class="button-container">
          <a mat-dialog-close class="close-tip">&nbsp;{{"general.cancel"|translate}}</a>
     </div>
</mat-dialog-actions>